<template>
    <div>

        <div class="vld-parent">
            <loading :active.sync="open_loader"
                     :can-cancel="false"
                     :is-full-page="true">
            </loading>
        </div>

        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Emailing</h5><br>
            </div>
            <div class="ibox-content">
                <forms
                    :settings="settings"
                    @onFormButtonClick="onFormButtonClick"
                    @onInput="onInput"
                ></forms>
            </div>
        </div>

        <div class="ibox">
            <div class="ibox-title">
                <h5>Emailing</h5><br>
                <button class="btn btn-primary" @click="sendMail('all')">Pošalji sve</button>
                <button class="btn btn-danger" @click="deleteMail('all')">Obriši sve</button>
            </div>
            <div class="ibox-content">
                <datatables
                    v-if="show_datatable"
                    :url="datatables_url"
                    :settings="datatables.settings"
                    :title="datatables.title"
                    @buttonClick="datatableButtonClick"
                >
                </datatables>
            </div>
        </div>
    </div>
</template>

<script>
import Datatables from "../../../../components/datatable/Datatables";
import SkupoviNavigation from "../SkupNavigation";
import Forms from "../../../../components/form/Forms";
import axios from "axios";
import Loading from "vue-loading-overlay";
import toastr from "toastr";
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: "SkupStavke",
    components: { SkupoviNavigation, Datatables, Forms, Loading },
    data(){
        return {
            skup_id: this.$route.params.skup_id,

            open_loader: false,

            // datatable
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'emailing',
            datatables: {},
            breadcrumbs: [],

            // form
            settings: {},
            errors: {},
            data: {},

            // select options
            potvrde_select: [],
            osobe_select: []
        }
    },
    methods:{

        async init(){
            this.open_loader = true
            await this.fetchPotvrde()
            await this.fetchOsobe()
            this.setupForm()
            this.setDatatable()
            this.setBreadcrumbs()
            this.open_loader = false
        },

        async fetchPotvrde(){
            let vm = this
            await axios.get( process.env.VUE_APP_API_URL + 'potvrda', {
                params:{
                    page: 1,
                    per_page: -1,
                    filters:{
                        predlozak: 'sudionik'
                    }
                }
            } )
                .then( response => {
                    response.data.data.forEach( item => {
                        vm.potvrde_select.push( {
                            key: item.id.toString(),
                            value: item.naziv
                        } )
                    })
                } )
                .catch( error => console.log( error ) )
        },

        async fetchOsobe(){
            let vm = this
            await axios.get( process.env.VUE_APP_API_URL + 'stavka', {
                params:{
                    page: 1,
                    per_page: -1,
                    filters: {
                        skup_id: vm.skup_id,
                        vrsta_sudionika_id: 1
                    }
                }
            } )
                .then( response => {
                    vm.osobe_select.push( {
                        'key': 'all',
                        'value': 'Svi'
                    } )
                    response.data.data.forEach( item => {
                        let exists = vm.getOsoba( item.osoba.id.toString() )

                        if( !(Boolean(exists))){
                            vm.osobe_select.push( {
                                key: item.osoba.id.toString(),
                                value: item.osoba.ime + ' ' + item.osoba.prezime + ' (' + item.osoba.oib + ')'
                            } )
                        }
                    })
                } )
                .catch( error => console.log( error ) )
        },

        getPotvrda( id ){
            return this.potvrde_select.find( item => item.key === id )
        },

        getOsoba( id ){
            return this.osobe_select.find( item => item.key === id )
        },


        setupForm(){

            let vm = this

            let cancel_button = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
            }

            let generate_button = {
                id: 'add',
                title: 'Dodaj',
                type: 'primary',
            }

            let buttons = []
            buttons.push( cancel_button )
            if(
                vm.data.osoba_ids
                &&
                vm.data.potvrda_id
            )
                buttons.push( generate_button )



            let osoba_ids_input = {
                name: 'osoba_ids',
                type: 'select',
                title: 'Osoba',
                value: vm.getOsoba( vm.data.osoba_ids ),
                width: 6,
                error: vm.errors['osoba_ids'] ? vm.errors['osoba_ids'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.osobe_select,
                    title_width: 3,
                    input_width: 9
                }
            }


            let potvrda_id_select = {
                name: 'potvrda_id',
                type: 'select',
                title: 'Potvrda',
                value: vm.getPotvrda( vm.data.potvrda_id ),
                width: 6,
                error: vm.errors['potvrda_id'] ? vm.errors['potvrda_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.potvrde_select,
                    title_width: 3,
                    input_width: 9
                }
            }


            let inputs = []
            inputs.push( osoba_ids_input )
            inputs.push( potvrda_id_select )

            let settings = {
                width: 12,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: inputs,
                            },
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },


        onInput( name, value ){
            let vm = this;
            if( vm.data[name] !== value ){
                vm.data[name] = value
                vm.setupForm()
            }
        },


        onFormButtonClick( id, action, config, data ){
            let vm = this
            if( id === 'add' ){
                vm.open_loader = true
                axios.get( process.env.VUE_APP_API_URL + 'emailing/' + vm.skup_id + '/add-to-mailing-list' , {
                    params: {
                        ...data
                    }
                } )
                    .then( response => {
                        console.log( response.data )
                        if( response.data.success ){
                            toastr.success( 'Uspješno kreirano!' )
                            vm.data = {}
                            vm.setupForm()
                            vm.setDatatable()
                            vm.open_loader = false
                        } else {
                            if( response.data.messages && response.data.messages.general ){
                                response.data.messages.general.forEach( item => {
                                    toastr.error( item )
                                } )
                            }
                            else{
                                toastr.error( 'Došlo je do greške!' )
                            }
                            vm.open_loader = false
                        }
                    } )
                    .catch( error => {
                        console.log( error )
                        vm.open_loader = false
                        toastr.error( 'Došlo je do greške!' )
                    } )
            } else if ( id === 'cancel' ){
                vm.data = {}
                vm.setupForm()
            }
        },



        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'skup_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.skup_id
                            },
                        },
                        {
                            'id': 'ime',
                            'title': 'Ime',
                            'type' : function( row ){
                                return row.osoba ? row.osoba.ime : ''
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'prezime',
                            'title': 'Prezime',
                            'type' : function( row ){
                                return row.osoba ? row.osoba.prezime : ''
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'oib',
                            'title': 'OIB',
                            'type' : function( row ){
                                return row.osoba ? row.osoba.oib : ''
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'send',
                            'title': '',
                            'searchable': false,
                            'type': 'button',
                            'filter': {
                                'type': 'none',
                                'search': '',
                                'value': null,
                            },
                            'column_visibility_group': {
                                id: 'emailing',
                            },
                            config: {
                                title: 'Pošalji',
                                type: 'primary',
                            }
                        },
                        {
                            'id': 'delete',
                            'title': '',
                            'searchable': false,
                            'type': 'button',
                            'filter': {
                                'type': 'none',
                                'search': '',
                                'value': null,
                            },
                            'column_visibility_group': {
                                id: 'emailing',
                            },
                            config: {
                                title: 'Obriši',
                                type: 'danger',
                            }
                        },
                        {
                            'id': 'potvrda_slanja',
                            'title': 'Potvrđeno slanje',
                            'type' : function( row ){
                                return row.potvrda_slanja ? 'Da' : 'Ne'
                            },
                            'filter': {
                                'type': 'select',
                                'search': [
                                    {
                                        key: '0',
                                        value: 'Ne'
                                    },
                                    {
                                        key: '1',
                                        value: 'Da'
                                    },

                                ],
                                'value': null
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'poslano',
                            'title': 'Poslano',
                            'type' : function( row ){
                                return row.poslano ? 'Da' : 'Ne'
                            },
                            'filter': {
                                'type': 'select',
                                'search': [
                                    {
                                        key: '0',
                                        value: 'Ne'
                                    },
                                    {
                                        key: '1',
                                        value: 'Da'
                                    },

                                ],
                                'value': null
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'uspjesno',
                            'title': 'Uspješno poslano',
                            'type' : function( row ){
                                return row.uspjesno ? 'Da' : 'Ne'
                            },
                            'filter': {
                                'type': 'select',
                                'search': [
                                    {
                                        key: '0',
                                        value: 'Ne'
                                    },
                                    {
                                        key: '1',
                                        value: 'Da'
                                    },

                                ],
                                'value': null
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'datum_i_vrijeme_slanja',
                            'title': 'Datum',
                            'type' : 'text',
                            'searchable': false,
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'log',
                            'title': 'Log',
                            'searchable': false,
                            'type' : function( row ){
                                return row.log
                            },
                            'column_visibility_group': {
                                'id': 'emailing',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'download',
                            'title': '',
                            'searchable': false,
                            'type': 'button',
                            'filter': {
                                'type': 'none',
                                'search': '',
                                'value': null,
                            },
                            'column_visibility_group': {
                                id: 'emailing',
                            },
                            config: {
                                title: 'Preuzmi PDF',
                                type: 'success',
                            }
                        },

                    ],
                    column_visibility_groups:{
                        'emailing' : 'Emailing'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Emailing',
            }
            vm.show_datatable = true;
        },


        async datatableButtonClick( col, row ){
            if( col.id === 'send' ){
                if( row.poslano ){
                    toastr.error( 'Email je već poslan!')
                } else {
                    await this.sendMail( row.id )
                }
            } else if( col.id === 'delete' ){
                if( row.poslano ){
                    toastr.error( 'Email je već poslan i ne može se brisati!')
                } else {
                    await this.deleteMail( row.id )
                }
            } else if( col.id === 'download' ){
                if( row.generirani_dokument ){
                    await this.downloadMailPDF( row.generirani_dokument_id )
                } else {
                    toastr.error( 'Datoteka nije generirana!')
                }
            }
        },

        async sendMail( id ){
            let vm = this;
            vm.open_loader = true;
            await axios.get( process.env.VUE_APP_API_URL + 'emailing/' + vm.skup_id + '/' + 'send/' + id )
                .then( response => {
                    console.log( response )
                    vm.setDatatable()
                    vm.open_loader = false;
                })
                .catch( error => {
                    console.log( error )
                    vm.open_loader = false;
                })
        },

        async deleteMail( id ){
            console.log( id )
            let vm = this;
            vm.open_loader = true;
            await axios.get( process.env.VUE_APP_API_URL + 'emailing/' + vm.skup_id + '/' + 'delete/' + id )
                .then( response => {
                    console.log( response )
                    vm.setDatatable()
                    vm.open_loader = false;
                })
                .catch( error => {
                    console.log( error )
                    vm.open_loader = false;
                })
        },

        async downloadMailPDF( id ){
            let vm = this;
            vm.open_loader = true;
            await axios.get( process.env.VUE_APP_API_URL + 'generirani-dokument/download-mail-pdf/' + id, {
                responseType: 'blob',
            } )
                .then( response => {
                    const url = window.URL.createObjectURL(new Blob([response.data] ) )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', id + '.pdf'  )
                    document.body.appendChild( link )
                    link.click()
                    vm.open_loader = false
                })
                .catch( error => {
                    console.log( error )
                    vm.open_loader = false;
                })
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/emailing',
                    name: 'Emailing'
                }
            ]
        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
